// import { atom, selector, selectorFamily, waitForAll } from 'recoil';
import { AUTH_API, COMPANY_API } from 'apis';
import { delay } from 'utils';
import moment from 'moment';
import storage from 'helpers/storage';

const NS = '/captain-payment';

// export const currentUserIdState = atom({
//   key: 'currentUserIdState',
//   default: null
// });

// export const currentDormantUserIdState = atom({
//   key: 'CurrentDormantUserIdState',
//   default: null
// });

// export const userRequestIdState = atom({
//   key: 'UserRequestIdState',
//   default: 0
// });

// export const divisionRequestIdState = atom({
//   key: 'DivisionRequestState',
//   default: 0
// });

// export const userInfoQuery = selectorFamily({
//   key: 'UserInfoQuery',
//   get: (userId: string) => async ({ get }) => {
//     if (!userId) return {};
//     get(userRequestIdState);
//     const result = await COMPANY_API.get(`${NS}/member/v1/${userId}`);
//     const { user: u } = result.data;
//     const { captainPaymentGrade, group, birthday } = u;
//     const user = {
//       ...u,
//       captainPaymentGrade: captainPaymentGrade ? captainPaymentGrade.type : captainPaymentGrade,
//       groupIdx: group ? group.groupIdx : group,
//       birthday: birthday ? moment(birthday) : birthday
//     };
//     return user;
//   }
// });

// export const mealGroupInfoQuery = selector({
//   key: 'MealGroupInfoQuery',
//   get: async () => {
//     const result = await COMPANY_API.get(`${NS}/member/v1/group`);
//     return result.data.group;
//   }
// });

// export const authInfoQuery = selector({
//   key: 'AuthInfoQuery',
//   get: async () => {
//     const result = await COMPANY_API.get(`${NS}/member/v1/auth`);
//     return result.data;
//   }
// });

// export const positionsQuery = selector({
//   key: 'PositionsQuery',
//   get: async () => {
//     const result = await COMPANY_API.get(`${NS}/member/v1/rankposition`);
//     return result.data.rankPosition;
//   }
// });

// export const divisionsQuery = selector({
//   key: 'DivisionsQuery',
//   get: async ({ get }) => {
//     get(divisionRequestIdState);
//     const result = await COMPANY_API.get(`${NS}/member/v1/division`);
//     return result.data;
//   }
// });

// export const dormantUserInfoQuery = selectorFamily({
//   key: 'DormantUserInfoQuery',
//   get: (userId: string) => async ({ get }) => {
//     if (!userId) return null;
//     get(userRequestIdState);
//     const result = await Promise.all([COMPANY_API.get(`${NS}/member/v1/dormant/${userId}`), delay(1000)]);
//     return result[0].data.dormantUser;
//   }
// });

export const dormantUserInfoAPI = async (userId) => {
  const result = await Promise.all([COMPANY_API.get(`${NS}/member/v1/dormant/${userId}`), delay(1000)]);
  return result[0].data.dormantUser;
};

// export const currentUserInfoQuery = selector({
//   key: 'CurrentUserInfoQuery',
//   get: ({ get }) => {
//     const { user, group, position, division, auth } = get(
//       waitForAll({
//         user: userInfoQuery(get(currentUserIdState)),
//         group: mealGroupInfoQuery,
//         position: positionsQuery,
//         division: divisionsQuery,
//         auth: authInfoQuery
//       })
//     );
//     return {
//       user,
//       group,
//       position,
//       division,
//       auth
//     };
//   },
// });

// export const myInfoQuery = selector({
//   key: 'myInfoQuery',
//   get: async () => {
//     const result = await COMPANY_API.get(`${NS}/pass/v1/employee`);
//     const { birthday } = result.data.user;

//     return {
//       ...result.data.user,
//       birthday: birthday ? moment(birthday) : birthday
//     };
//   }
// });

export const myEmployeeInfoAPI = async () => {
  const { auth } = storage.get('info') || {};
  if (!auth) return;
  const result = await COMPANY_API.get(`${NS}/pass/v1/employee`, {
    headers: {
      'x-comid': auth.organization
    }
  });

  return {
    ...result.data.user
  };
};

// export const currentDormantUserInfoQuery = selector({
//   key: 'CurrentDormantUserInfoQuery',
//   get: ({ get }) => get(dormantUserInfoQuery(get(currentDormantUserIdState)))
// });

export const modifyUser = async (userId, data) => {
  const result = await COMPANY_API.put(`${NS}/member/v1/${userId}`, data);
  return result;
};

// 권한 변경 시 대마플(corp-api) 토큰만 조회해 폐기 — 강제 로그아웃과 달리 다른 서비스 세션은 유지
export const logoutCorpTokens = async (userId) => {
  try {
    const result = await AUTH_API.get(`/oauth2/v2/${userId}/tokens`, {
      params: { applicationName: 'corp-api' }
    });
    const { tokens = [] } = result.data || {};
    await Promise.all(tokens.map((token) => AUTH_API.delete(`/oauth2/tokens/${token}`)));
    return result.data;
  } catch (e) {
    throw new Error(e);
  }
};

export const createUser = async (data) => {
  const result = await COMPANY_API.post(`${NS}/member/v1`, data);
  return result;
};

export const modifyMyInfo = async (data) => {
  const result = await COMPANY_API.put(`${NS}/pass/v1/employee`, data);
  return result;
};
